import { render } from "./ListLicenses.vue?vue&type=template&id=3c7f84d8&ts=true"
import script from "./ListLicenses.vue?vue&type=script&lang=ts"
export * from "./ListLicenses.vue?vue&type=script&lang=ts"

import "./Licenses.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__